import { Button } from '@repo/ui/button'
import { cn } from '@repo/ui/utils'
import { Pencil } from 'lucide-react'

import { beneficiaryInsightsActions as actions } from '@/store/beneficiary-insights/slice'
import { InsightWidget } from '@/store/beneficiary-insights/types'
import { useStoreDispatch } from '@/store/hooks'

import { Card } from '../cards/Card'

export function EditModeCard({
  widget,
  colSpanCss,
  rowSpanCss,
}: {
  widget: InsightWidget
  colSpanCss: string
  rowSpanCss: string
}) {
  const dispatch = useStoreDispatch()

  return (
    <div
      key={widget.id}
      className={cn(colSpanCss, rowSpanCss, 'max-h-[30rem] overflow-y-auto relative')}
    >
      <div className="absolute top-2 right-2 z-10 text-white">
        <Button
          variant="outline"
          size="icon"
          onClick={() => dispatch(actions.openWidgetConfigurationEditDialog(widget.id))}
        >
          <Pencil className="size-4" />
        </Button>
      </div>
      <Card widget={widget} />
    </div>
  )
}
